import { FA_MEMBER_ROLES } from '@constants/member-roles';
import { Profile } from '@model/profile';
import { validateUserRoles } from './validate-user-roles';

/* Member refers to members of system (Financial Advisor) */
export default function isFAMember(profile: Nullable<Profile>): boolean {
  return validateUserRoles(profile, FA_MEMBER_ROLES);
}
